import { Component, NgZone, OnDestroy } from "@angular/core";
import { LoggerService } from "../../../../common/logging/logger.service";
import { MonthlyGoalServiceData, MonthlyTargetsService } from "../../services/monthlyTargetsKpi/monthlyTargetsKpi.service";
import { MonthlyTargetsKpiCfgService } from "../../services/monthlyTargetsKpi/monthlyTargetsKpiCfg.service";
import { SingleSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";

@Component({
    selector: "monthly-targets-kpi-service-host",
    template: "<ng-content></ng-content>",
    standalone: false
})
export class MonthlyTargetsKpiServiceHostComponent
  extends SingleSummaryDetailKpiServiceHost<MonthlyTargetsService, MonthlyGoalServiceData, MonthlyGoalServiceData, MonthlyGoalServiceData> implements OnDestroy
{
  public getClassName() {
    return "MonthlyTargetsKpiServiceHostComponent";
  }

  private intervalHandle: ReturnType<typeof setInterval>;
  public enabled: boolean;

  constructor(
    zone: NgZone,
    logger: LoggerService,
    summaryDetailService: MonthlyTargetsService,
    cfg: MonthlyTargetsKpiCfgService
  ) {
    super(zone, logger, summaryDetailService);

    this.enabled = cfg.getCfg().enabled;

    this.updateSummary();

    this.intervalHandle = setInterval(() => this.updateSummary(), 3600000);
  }

  protected processSummaryData(
    data: MonthlyGoalServiceData
  ): MonthlyGoalServiceData {
    return data;
  }

  protected getDefaultSummaryData(): MonthlyGoalServiceData {
    return new MonthlyGoalServiceData();
  }

  protected extractUpdateTime(data: MonthlyGoalServiceData): Date {
    return null;
  }

  protected processDetailData(
    data: MonthlyGoalServiceData
  ): MonthlyGoalServiceData {
    return data;
  }

  public ngOnDestroy() {
    if (this.intervalHandle) clearInterval(this.intervalHandle);
  }
}
